<div class="section-container {{colorScheme.main}} {{titleSize}}" >
  <!--TITLE-->
  <div class="title-container">
    <mat-icon
      class="title-icon {{titleSize}}"
      [class.large]="pageTitle"
      *ngIf="titleIcon">
      {{titleIcon}}
    </mat-icon>
    <lib-lazy-image
      *ngIf="titleIconUrl"
      [imgUrl]="titleIconUrl"
      [targetRes]="imageResolution"
      class="title-image">
    </lib-lazy-image>
    <h3 *ngIf="!pageTitle" class="title {{titleSize}}">
      {{title}}
      <small *ngIf="subTitle">{{subTitle}}</small>
    </h3>
    <h1 *ngIf="pageTitle" class="title">
      {{title}}
    </h1>
  </div>
  <!--BUTTON-->
  <a *ngIf="buttonTitle && routerLink"
    class="section-button"
    [routerLink]="routerLink"
  >
    {{buttonTitle}}
    <mat-icon>chevron_right</mat-icon>
  </a>
</div>
